module.exports = __webpack_public_path__ + "static/media/UNIEMPLEO-Animation_1.58b01098.mp4";